import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import { Ability, AnyAbility } from '@casl/ability';

const initialAbility = new Ability( [] );
export const AbilityContext = createContext<AnyAbility>( initialAbility );
export const Can = createContextualCan(AbilityContext.Consumer);